import { iProProjectMain } from "../models/interfaceProject";

export const updatePageInformation = (
    vProject: iProProjectMain 
  ) => {
    
    if (typeof document === "undefined") return; // Evita errores en SSR
  
    const updateFavicon = (rel: string) => {
      const iconUrl = vProject?.project?.icono ?? "";
      let link = document.head.querySelector<HTMLLinkElement>(`link[rel='${rel}']`);
    
      if (!link) {
        link = Object.assign(document.createElement("link"), { rel, href: iconUrl });
        document.head.appendChild(link);
      } else if (link.href !== iconUrl) {
        link.href = iconUrl; // Solo actualiza si cambia
      }
    };
    
    // Actualizar múltiples favicons de forma eficiente
    ["icon", "apple-touch-icon"].forEach(updateFavicon);
  
    // Actualiza el título de la página
    document.title = vProject.project.project_name;          
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute("content", vProject.project.description);
    }

   
  };
  